import React from 'react';
import PropTypes from 'prop-types';
import { Flag } from 'semantic-ui-react';

import './CountryFlag.css';

const CountryFlag = ({ name }) => {
  const _calculateLabel = () => {
    const label = name.toLowerCase().split(', ');

    if (label.indexOf('czechia') !== -1) { return 'czech republic'; }
    if (label.indexOf('côte d\'ivoire') !== -1) { return 'cote divoire'; }
    if (label.indexOf('sāmoa') !== -1) { return 'samoa'; }
    if (label.indexOf('macao') !== -1) { return 'macau'; }

    /* Flags that are not supported by Flag component */
    if (label.indexOf('jersey') !== -1) { return 'jersey'; }
    if (label.indexOf('south ossetia') !== -1) { return 'south-ossetia'; }
    if (label.indexOf('kosovo') !== -1) { return 'kosovo'; }
    if (label.indexOf('abkhazia') !== -1) { return 'abkhazia'; }
    if (label.indexOf('palestinian territories') !== -1) { return 'palestinian-territories'; }
    if (label.indexOf('cabo verde') !== -1) { return 'cabo-verde'; }
    if (label.indexOf('batumi bay') !== -1) { return 'batumi-bay'; }

    return label;
  };
  return (
    <div className="country-flag__component">
      <Flag
        name={_calculateLabel()}
      />
    </div>
  );
};

CountryFlag.propTypes = {
  name: PropTypes.string.isRequired,
};

export default CountryFlag;
